<!--
  @component
  Generates an SVG x-axis. This component is also configured to detect if your x-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
 <script>
  import { getContext } from 'svelte';
  import TickX from './TickX.svelte';

  const { width, height, xScale, yRange, xDomain } = getContext('LayerCake');

  /** @type {Boolean} [gridlines=true] - Extend lines from the ticks into the chart space */
  export let gridlines = true;


  /** @type {Boolean} [baseline=false] – Show a solid line at the bottom. */
  export let baseline = false;

  /** @type {Function} [formatTick=d => d] - A function that passes the current tick value and expects a nicely formatted value in return. */
  export let formatTick = d => d;

  export let xTicks;
  export let yTicks;
</script>

<g class="axis x-axis">
  {#each xTicks as tick, i (tick.getFullYear())}
    <TickX
      {formatTick}
      {tick}
      {yTicks}
    />
  {/each}
  {#if baseline === true}
    <line class="baseline" y1={$height + 0.5} y2={$height + 0.5} x1="0" x2={$width} />
  {/if}
</g>

<style>
  .baseline {
    stroke-dasharray: 0;
  }
</style>